<template>
	<div :class="{ 'video-overlay': !playStarted }" class="pxlt-video">
		<video ref="pxltVideo" :src="source" alt="Pixellot Video" />
		<button v-show="!playStarted" class="btn-play" @click="playVideo" />
	</div>
</template>

<script>
export default {
	name: 'PxltVideo',
	props: {
		src: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			playStarted: false
		}
	},
	computed: {
		source () {
			return this.$nuxt.context.env.staticUrl + this.src
		}
	},
	methods: {
		playVideo () {
			const playPromise = this.$refs.pxltVideo.play()

			if (playPromise) {
				playPromise
					.then(() => {
						this.$refs.pxltVideo.controls = true
						this.playStarted = true
					})
					.catch((error) => {
						this.$log.error('Error during video play', error)
					})
			}
		}
	}
}
</script>

<style lang="scss">
.pxlt-video {
  position: relative;

  video {
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: 700px;
    object-fit: cover;
  }

  &.video-overlay::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #dddddd;
    border: 1px solid #707070;
  }

  .btn-play {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 160px;
    width: 160px;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    color: $black;
    background-color: $white;
    border: 1px solid #707070;
    border-radius: 50%;
    transition: 0.6s;

    &::after {
      content: "";
      border: 0;
      background: transparent;
      box-sizing: border-box;
      width: 0;
      height: 74px;
      margin-left: 15px;

      border-color: transparent transparent transparent #646464;
      cursor: pointer;

      border-style: solid;
      border-width: 37px 0 37px 60px;
      transition: 0.6s;
    }

    &:hover {
      font-size: 30px;
      color: $white;
      background-color: $primary;

      &::after {
        border-color: transparent transparent transparent $white;
      }
    }

    @include respond-below(phone) {
      top: 40%;
      height: 80px;
      width: 80px;
      &::after {
        height: 37px;
        margin-left: 8px;
        border-width: 18px 0 18px 30px;
      }
    }
  }
}
</style>
